import { MatrixItemField } from './matrix.item.field';

export class MatrixItem {
  ID: string;
  SHORT_CODE: string;
  FULL_NAME: string;
  FIELDS: MatrixItemField[];

  constructor(value: any = {}) {
    Object.assign(this, value);

    if (value.FIELDS) {
      this.FIELDS = MatrixItemField.parseArray(value.ITEMS);
    }
  }

  static parseArray(json: any[]): MatrixItem[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new MatrixItem(j));
        }
      }
    }

    return arr;
  }

}
